import React, { FC } from 'react';

import cn from 'classnames';
import scss from 'components/shared.module.scss';
import * as dt from 'core/datetime';
import { weekNumberToString } from 'globals/constants';

import { ReactComponent as CrossIcon } from 'assets/cross.svg';

import css from './WeeklyClass.module.scss';

interface WeeklyClassProps extends CourseScheduleData {
  className?: string;
  onDelete(): void;
}

const formatTime = (time: string) => dt.serialize24HoursTime(dt.parseTimeString(time));

const WeeklyClass: FC<WeeklyClassProps> = (props) => {
  return (
    <div className={cn('cell', props.className)}>
      <div className='cell__user'>
        <div className={`cell__details ${css['weekly-class-day']}`}>
          <p className='capitalize'>
            {weekNumberToString[props.day]}, {formatTime(props.startTime)} - {formatTime(props.endTime)}
          </p>
          <p className='cell__details--email'>
            {props.isOnlineMeeting ? (
              'This is an online class'
            ) : (
              <>
                <span className='capitalize'>{props.type}</span> at {props.venue}
              </>
            )}
          </p>
        </div>
      </div>
      <div className='cell__actions'>
        <span className='remove-action' onClick={props.onDelete}>
          <CrossIcon className={scss['cross-icon']} />
        </span>
      </div>
    </div>
  );
};
export default WeeklyClass;
